import { render } from "./UTIPanelSelectedTests.vue?vue&type=template&id=72d02582&scoped=true"
import script from "./UTIPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./UTIPanelSelectedTests.vue?vue&type=script&lang=js"

import "./UTIPanelSelectedTests.vue?vue&type=style&index=0&id=72d02582&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d02582"],['__file',"src/components/cases/testInfo/selectedTestsPreview/UTIPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72d02582"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72d02582', __exports__)) {
    console.log('reload')
    api.reload('72d02582', __exports__)
  }
  
  module.hot.accept("./UTIPanelSelectedTests.vue?vue&type=template&id=72d02582&scoped=true", () => {
    console.log('re-render')
    api.rerender('72d02582', render)
  })

}


export default __exports__